import { render } from "./form.vue?vue&type=template&id=14cd7ded"
import script from "./form.vue?vue&type=script&lang=js"
export * from "./form.vue?vue&type=script&lang=js"

import "./form.vue?vue&type=style&index=0&id=14cd7ded&lang=less"

import exportComponent from "/Users/zhanghui/Documents/workSpace/github/coco-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__